const clickDeliver = (state = {}, data) => {
    switch (data.type) {
        case 'UPDATE_COLLECTION_ZIPS':
            return {
                ...state,
                zips: data.zips,
            };
        case 'SET_DELIVER_ERROR':
            return {
                ...state,
                error: data.code,
            };
        default:
            return state;
    }
};

export default clickDeliver;
